import { LOOKUP_GENDER, LOOKUP_RACE, LOOKUP_YESORNO, LOOKUP_YESORNODONTKNOW, LOOKUP_ENGLISH, LOOKUP_COUNTRY, LOOKUP_STATE, LOOKUP_PROVINCE, LOOKUP_EDUCATION,
    LOOKUP_STUDENT, LOOKUP_DEGREES, LOOKUP_GPA, LOOKUP_EMPLOYEMENTSTATUS, LOOKUP_ORGANIZATIONLEVEL, LOOKUP_DIRECTREPORTS,
    LOOKUP_OCCUPATIONALAREA, LOOKUP_OCCUPATION, LOOKUP_DIAGNOSED, LOOKUP_ETHNIC_ORIGINS,
} from '../src/redux/actions/lookup-action';

const RESPONSE_DEFAULT = undefined;

const facilitationTasks = {
    "id": 1,
    "name": "Facilitation",
    "rank": 11,
    "practice": [
        {
            "id": 1,
            "question": "A woman is composing music to accompany a military march. Which mood will help this woman perform this task most effectively?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 1,
                    "label": "Aggresiveness"
                },
                {
                    "value": 2,
                    "label": "Disappointment"
                },
                {
                    "value": 3,
                    "label": "Carefree"
                },
                {
                    "value": 4,
                    "label": "Cocntentment"
                }
            ],
            "response": null
        }
    ],
    "attention": [],
    "tasks": [
        {
            "id": 2,
            "question": "A man is using a complicated recipe to prepare a meal. Which mood will help this man perform this task most effectively?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 5,
                    "label": "Tension"
                },
                {
                    "value": 6,
                    "label": "Solemnness"
                },
                {
                    "value": 7,
                    "label": "Neutral mood"
                },
                {
                    "value": 8,
                    "label": "Optimism"
                }
            ],
            "response": null
        },
        {
            "id": 3,
            "question": "A man is setting personal goals for the upcoming year and he needs to reflect upon and identify the areas that he wants to improve. Which mood will help this man perform this task most effectively?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 9,
                    "label": "Enthusiasm"
                },
                {
                    "value": 10,
                    "label": "Apprehension"
                },
                {
                    "value": 11,
                    "label": "Restlessness"
                },
                {
                    "value": 12,
                    "label": "Serenity"
                }
            ],
            "response": null
        },
        {
            "id": 4,
            "question": "An advertising employee needs to brainstorm ideas for a new marketing campaign. Which mood will help the employee perform this task most effectively?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 13,
                    "label": "Calmness"
                },
                {
                    "value": 14,
                    "label": "Tiredness"
                },
                {
                    "value": 15,
                    "label": "Happiness"
                },
                {
                    "value": 16,
                    "label": "Anxiety"
                }
            ],
            "response": null
        },
        {
            "id": 5,
            "question": "A team needs to agree upon which course of action should be taken to resolve a major client’s complaint about the team’s product. Which mood will most effectively help the team members to reach a consensus about their next course of action?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 17,
                    "label": "Calmness"
                },
                {
                    "value": 18,
                    "label": "Cheerfulness"
                },
                {
                    "value": 19,
                    "label": "Inspiration"
                },
                {
                    "value": 20,
                    "label": "Worry"
                }
            ],
            "response": null
        }
    ]
}

const sensationsTasks = {
    "id": 2,
    "name": "Sensations",
    "rank": 2,
    "practice": [
        {
            "id": 6,
            "question": "Tightness in the stomach, sweaty palms, and rapid heart rate are most likely signs of which emotions?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 21,
                    "label": "Anger"
                },
                {
                    "value": 22,
                    "label": "Anxiety"
                },
                {
                    "value": 23,
                    "label": "Confusion"
                },
                {
                    "value": 24,
                    "label": "Sadness"
                }
            ],
            "response": null
        }
    ],
    "attention": [
        {
            "id": 13,
            "question": "Attention check item: A common stomach ailment is...",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 49,
                    "label": "Fever"
                },
                {
                    "value": 50,
                    "label": "Indigestion"
                },
                {
                    "value": 51,
                    "label": "Arthritis"
                },
                {
                    "value": 52,
                    "label": "Headache"
                }
            ],
            "response": null
        }
    ],
    "tasks": [
        {
            "id": 7,
            "question": "Feeling cold is most likely a sign of which emotion?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 25,
                    "label": "Disgust"
                },
                {
                    "value": 26,
                    "label": "Guilt"
                },
                {
                    "value": 27,
                    "label": "Fear"
                },
                {
                    "value": 28,
                    "label": "Shame"
                }
            ],
            "response": null
        },
        {
            "id": 8,
            "question": "Feeling as if one’s throat is constricted is most likely a sign of which emotion?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 29,
                    "label": "Calmness"
                },
                {
                    "value": 30,
                    "label": "Joy"
                },
                {
                    "value": 31,
                    "label": "Sadness"
                },
                {
                    "value": 32,
                    "label": "Shame"
                }
            ],
            "response": null
        },
        {
            "id": 9,
            "question": "Increased heart rate, deep breathing, and a sense of warmth are most likely signs of which emotion?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 33,
                    "label": "Anger"
                },
                {
                    "value": 34,
                    "label": "Happiness"
                },
                {
                    "value": 35,
                    "label": "Fear"
                },
                {
                    "value": 36,
                    "label": "Shame"
                }
            ],
            "response": null
        },
        {
            "id": 10,
            "question": "Increased blood pressure, increased heart rate, and feeling hot are most likely signs of which emotion?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 37,
                    "label": "Anger"
                },
                {
                    "value": 38,
                    "label": "Fear"
                },
                {
                    "value": 39,
                    "label": "Guilt"
                },
                {
                    "value": 40,
                    "label": "Happiness"
                }
            ],
            "response": null
        },
        {
            "id": 11,
            "question": "Sadness is most likely characterized by which breathing pattern?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 41,
                    "label": "Fast, deep breathing"
                },
                {
                    "value": 42,
                    "label": "Fast, shallow breathing"
                },
                {
                    "value": 43,
                    "label": "Slow, deep breathing"
                },
                {
                    "value": 44,
                    "label": "Slow, shallow breathing"
                }
            ],
            "response": null
        },
        {
            "id": 12,
            "question": "Guilt is most likely characterized by which sensation?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 45,
                    "label": "Warmth"
                },
                {
                    "value": 46,
                    "label": "A rapid heartbeat"
                },
                {
                    "value": 47,
                    "label": "Relaxed muscles"
                },
                {
                    "value": 48,
                    "label": "Sweating"
                }
            ],
            "response": null
        }
    ]
}

const contextualPicturesTasks = {
    "id": 3,
    "name": "ContextualPictures",
    "rank": 5,
    "practice": [
        {
            "id": 14,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Practice-Item.png"
            ],
            "options": [
                {
                    "value": 53,
                    "label": "Annoyance"
                },
                {
                    "value": 54,
                    "label": "Boredom"
                },
                {
                    "value": 55,
                    "label": "Sadness"
                },
                {
                    "value": 56,
                    "label": "Discouragement"
                },
                {
                    "value": 57,
                    "label": "Embarrassment"
                }
            ],
            "response": null
        }
    ],
    "attention": [
        {
            "id": 23,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Attention-Item.png"
            ],
            "options": [
                {
                    "value": 98,
                    "label": "One"
                },
                {
                    "value": 99,
                    "label": "Two"
                },
                {
                    "value": 100,
                    "label": "Three"
                },
                {
                    "value": 101,
                    "label": "Four"
                },
                {
                    "value": 102,
                    "label": "Four"
                }
            ],
            "response": null
        }
    ],
    "tasks": [
        {
            "id": 15,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Item1.png"
            ],
            "options": [
                {
                    "value": 58,
                    "label": "Anger"
                },
                {
                    "value": 59,
                    "label": "Anticipation"
                },
                {
                    "value": 60,
                    "label": "Anxiety"
                },
                {
                    "value": 61,
                    "label": "Despair"
                },
                {
                    "value": 62,
                    "label": "Triumph"
                }
            ],
            "response": null
        },
        {
            "id": 16,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Item2.png"
            ],
            "options": [
                {
                    "value": 63,
                    "label": "Anger"
                },
                {
                    "value": 64,
                    "label": "Contempt"
                },
                {
                    "value": 65,
                    "label": "Fear"
                },
                {
                    "value": 66,
                    "label": "Worry"
                },
                {
                    "value": 67,
                    "label": "Happiness"
                }
            ],
            "response": null
        },
        {
            "id": 17,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Item3.png"
            ],
            "options": [
                {
                    "value": 68,
                    "label": "Sympathy"
                },
                {
                    "value": 69,
                    "label": "Alarm"
                },
                {
                    "value": 70,
                    "label": "Awe"
                },
                {
                    "value": 71,
                    "label": "Happiness"
                },
                {
                    "value": 72,
                    "label": "Surprise"
                }
            ],
            "response": null
        },
        {
            "id": 18,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Item4.png"
            ],
            "options": [
                {
                    "value": 73,
                    "label": "Caution"
                },
                {
                    "value": 74,
                    "label": "Anger"
                },
                {
                    "value": 75,
                    "label": "Disgust"
                },
                {
                    "value": 76,
                    "label": "Fear"
                },
                {
                    "value": 77,
                    "label": "Surprise"
                }
            ],
            "response": null
        },
        {
            "id": 19,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Item5.png"
            ],
            "options": [
                {
                    "value": 78,
                    "label": "Shame"
                },
                {
                    "value": 79,
                    "label": "Fear"
                },
                {
                    "value": 80,
                    "label": "Surprise"
                },
                {
                    "value": 81,
                    "label": "Guilt"
                },
                {
                    "value": 82,
                    "label": "Sadness"
                }
            ],
            "response": null
        },
        {
            "id": 20,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Item6.png"
            ],
            "options": [
                {
                    "value": 83,
                    "label": "Sadness"
                },
                {
                    "value": 84,
                    "label": "Contentment"
                },
                {
                    "value": 85,
                    "label": "Confidence"
                },
                {
                    "value": 86,
                    "label": "Happiness"
                },
                {
                    "value": 87,
                    "label": "Disgust"
                }
            ],
            "response": null
        },
        {
            "id": 21,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Item7.png"
            ],
            "options": [
                {
                    "value": 88,
                    "label": "Shame"
                },
                {
                    "value": 89,
                    "label": "Fear"
                },
                {
                    "value": 90,
                    "label": "Embarrassment"
                },
                {
                    "value": 91,
                    "label": "Disappointment"
                },
                {
                    "value": 92,
                    "label": "Sadness"
                }
            ],
            "response": null
        },
        {
            "id": 22,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/contextual/Item8.png"
            ],
            "options": [
                {
                    "value": 93,
                    "label": "Anger"
                },
                {
                    "value": 94,
                    "label": "Pride"
                },
                {
                    "value": 95,
                    "label": "Sadness"
                },
                {
                    "value": 96,
                    "label": "Disapproval"
                },
                {
                    "value": 97,
                    "label": "Contentment"
                }
            ],
            "response": null
        }
    ]
}

const changesTasks = {
    "id": 4,
    "name": "Changes",
    "rank": 6,
    "practice": [
        {
            "id": 24,
            "question": "A woman wa annoyed that a coworker took credit for  project, and when he did it again sher felt...",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 103,
                    "label": "Angry"
                },
                {
                    "value": 104,
                    "label": "Disappointment"
                },
                {
                    "value": 105,
                    "label": "Carefree"
                },
                {
                    "value": 106,
                    "label": "Contentment"
                }
            ],
            "response": null
        }
    ],
    "attention": [],
    "tasks": [
        {
            "id": 25,
            "question": "A woman felt content as she thought of her life. As she continued to think about the good things she had done and the joy her acts had brought to others, the more she felt...",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 107,
                    "label": "Happy"
                },
                {
                    "value": 108,
                    "label": "Amazed"
                },
                {
                    "value": 109,
                    "label": "Obligated"
                },
                {
                    "value": 110,
                    "label": "Surprised"
                }
            ],
            "response": null
        },
        {
            "id": 26,
            "question": "A man is content at work. He thought that he and his coworkers were fairly paid and treated well. Today, the entire office received a pay increase as part of company-wide adjustments in salary. This man felt...",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 111,
                    "label": "Astonished and shocked"
                },
                {
                    "value": 112,
                    "label": "Peaceful and quiet"
                },
                {
                    "value": 113,
                    "label": "Surprised and happy"
                },
                {
                    "value": 114,
                    "label": "Proud and dominant"
                }
            ],
            "response": null
        },
        {
            "id": 27,
            "question": "After a man’s car was stolen, he purchased a new car with a car alarm. When his new car was also stolen, he felt shocked and surprised at first. Then, the man felt...",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 115,
                    "label": "Amazed and astonished"
                },
                {
                    "value": 116,
                    "label": "Helpless, despaired, and angry"
                },
                {
                    "value": 117,
                    "label": "Angry and disgusted"
                },
                {
                    "value": 118,
                    "label": "Calm and resigned"
                }
            ],
            "response": null
        },
        {
            "id": 28,
            "question": "A child who was happily anticipating her birthday later felt sad. What most likely happened in between?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 119,
                    "label": "A bully insulted her and she fought back"
                },
                {
                    "value": 120,
                    "label": "Two friends who she hoped would come never made it to the party"
                },
                {
                    "value": 121,
                    "label": "Her mother embarrassed her in front of the other children"
                },
                {
                    "value": 122,
                    "label": "Her father accused her of something she did not do"
                }
            ],
            "response": null
        },
        {
            "id": 29,
            "question": "A man was full of interest and then felt admiration. What most likely happened in between?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 123,
                    "label": "The man heard a story about a sports hero who set a new world record"
                },
                {
                    "value": 124,
                    "label": "The man solved an important problem at work"
                },
                {
                    "value": 125,
                    "label": "His friend called to say he had just purchased a new car at a great price"
                },
                {
                    "value": 126,
                    "label": "A package arrived with a gift from his mother"
                }
            ],
            "response": null
        },
        {
            "id": 30,
            "question": "A woman felt anticipation and then she felt joy. What most likely happened in between?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 127,
                    "label": "She gave a donation and thought about the people she would help"
                },
                {
                    "value": 128,
                    "label": "She heard that her favorite novelist was releasing a new book"
                },
                {
                    "value": 129,
                    "label": "Her mother called to tell her she was sending a surprise birthday gift"
                },
                {
                    "value": 130,
                    "label": "She was called back for a second-round interview"
                }
            ],
            "response": null
        },
        {
            "id": 31,
            "question": "An executive in a corporation felt anticipation and then resentment. What most likely happened in between?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 131,
                    "label": "One of the executive’s employees failed to achieve his sales goals for the period"
                },
                {
                    "value": 132,
                    "label": "Another person in the company, whom he believed to be incompetent, got a promotion that the executive applied for"
                },
                {
                    "value": 133,
                    "label": "Few people attended one of his routine staff meetings"
                },
                {
                    "value": 134,
                    "label": "He read a news item about people living in poverty and how a major charity was facing obstacles in its relief efforts"
                }
            ],
            "response": null
        },
        {
            "id": 32,
            "question": "A woman was angry and then felt guilty. What most likely happened in between?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 135,
                    "label": "She didn’t finish a job as well as she had hoped to because she didn’t have enough time"
                },
                {
                    "value": 136,
                    "label": "She made a promise to a friend but then forgot about it"
                },
                {
                    "value": 137,
                    "label": "She confronted her friend about hurting her, then she discovered the friend hadn’t done anything"
                },
                {
                    "value": 138,
                    "label": "She lost a close friend"
                }
            ],
            "response": null
        },
        {
            "id": 33,
            "question": "A man liked his friend and then despised him. What most likely happened in between?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 139,
                    "label": "His friend lost an expensive book that the man loaned him"
                },
                {
                    "value": 140,
                    "label": "His friend received a larger salary increase than the man"
                },
                {
                    "value": 141,
                    "label": "The man felt he had hurt his friend and it was partly his friend’s fault"
                },
                {
                    "value": 142,
                    "label": "His friend betrayed the man’s wife"
                }
            ],
            "response": null
        },
        {
            "id": 34,
            "question": "A man loved someone and then felt secure. What most likely happened in between?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 143,
                    "label": "He learned the other person loved him in return"
                },
                {
                    "value": 144,
                    "label": "His expression of love was happily accepted by the other person"
                },
                {
                    "value": 145,
                    "label": "He decided not to express his feelings"
                },
                {
                    "value": 146,
                    "label": "His love for the other person decreased"
                }
            ],
            "response": null
        }
    ]
}

const moodMeterTasks = {
    "id": 5,
    "name": "MoodMeter",
    "rank": 3,
    "practice": [
        {
            "id": 35,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/emotions/Practice.png"
            ],
            "options": [
                {
                    "value": 147,
                    "label": "Annoyance"
                },
                {
                    "value": 148,
                    "label": "Delight"
                },
                {
                    "value": 149,
                    "label": "Boredom"
                },
                {
                    "value": 150,
                    "label": "Excitement"
                }
            ],
            "response": null
        }
    ],
    "attention": [
        {
            "id": 43,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/emotions/Attention.png"
            ],
            "options": [
                {
                    "value": 179,
                    "label": "Sadness and Happiness"
                },
                {
                    "value": 180,
                    "label": "Excitement and Sleepiness"
                },
                {
                    "value": 181,
                    "label": "Pleasantness and Energy"
                },
                {
                    "value": 182,
                    "label": "Internal and External"
                }
            ],
            "response": null
        }
    ],
    "tasks": [
        {
            "id": 36,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/emotions/Item1.png"
            ],
            "options": [
                {
                    "value": 151,
                    "label": "Calm"
                },
                {
                    "value": 152,
                    "label": "Excited"
                },
                {
                    "value": 153,
                    "label": "Hopeful"
                },
                {
                    "value": 154,
                    "label": "Interested"
                }
            ],
            "response": null
        },
        {
            "id": 37,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/emotions/Item2.png"
            ],
            "options": [
                {
                    "value": 155,
                    "label": "Frustrated"
                },
                {
                    "value": 156,
                    "label": "Disgusted"
                },
                {
                    "value": 157,
                    "label": "Satisfied"
                },
                {
                    "value": 158,
                    "label": "Sad"
                }
            ],
            "response": null
        },
        {
            "id": 38,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/emotions/Item3.png"
            ],
            "options": [
                {
                    "value": 159,
                    "label": "Alarmed"
                },
                {
                    "value": 160,
                    "label": "Astonished "
                },
                {
                    "value": 161,
                    "label": "Calm"
                },
                {
                    "value": 162,
                    "label": "Excited"
                }
            ],
            "response": null
        },
        {
            "id": 39,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/emotions/Item4.png"
            ],
            "options": [
                {
                    "value": 163,
                    "label": "Content"
                },
                {
                    "value": 164,
                    "label": "Happy"
                },
                {
                    "value": 165,
                    "label": "Interested"
                },
                {
                    "value": 166,
                    "label": "Sad"
                }
            ],
            "response": null
        },
        {
            "id": 40,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/emotions/Item5.png"
            ],
            "options": [
                {
                    "value": 167,
                    "label": "Annoyed"
                },
                {
                    "value": 168,
                    "label": "Astonished"
                },
                {
                    "value": 169,
                    "label": "Depressed"
                },
                {
                    "value": 170,
                    "label": "Terror"
                }
            ],
            "response": null
        },
        {
            "id": 41,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/emotions/Item6.png"
            ],
            "options": [
                {
                    "value": 171,
                    "label": "Disappointed"
                },
                {
                    "value": 172,
                    "label": "Angry"
                },
                {
                    "value": 173,
                    "label": "Happy"
                },
                {
                    "value": 174,
                    "label": "Impatient"
                }
            ],
            "response": null
        },
        {
            "id": 42,
            "question": "",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/emotions/Item7.png"
            ],
            "options": [
                {
                    "value": 175,
                    "label": "Shame"
                },
                {
                    "value": 176,
                    "label": "Disappointed"
                },
                {
                    "value": 177,
                    "label": "Frustrated"
                },
                {
                    "value": 178,
                    "label": "Rage"
                }
            ],
            "response": null
        }
    ]
}

const blendsTasks = {
    "id": 6,
    "name": "Blends",
    "rank": 7,
    "practice": [
        {
            "id": 44,
            "question": "A person who feels <b>aggressiveness</b> is actually fooling a combination of which <b><u>two</u></b> emotions?",
            "description": "",
            "numberOfResponses": 2,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 183,
                    "label": "Anger"
                },
                {
                    "value": 184,
                    "label": "Disgust"
                },
                {
                    "value": 185,
                    "label": "Sadness"
                },
                {
                    "value": 186,
                    "label": "Anticipation"
                },
                {
                    "value": 187,
                    "label": "Fear"
                },
                {
                    "value": 188,
                    "label": "Surprise"
                }
            ],
            //"response": null
        }
    ],
    "attention": [
        {
            "id": 54,
            "question": "A person who is dressed in summer clothes while standing outside in the snow is likely to be...",
            "description": "",
            "numberOfResponses": 2,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 243,
                    "label": "Shivering"
                },
                {
                    "value": 244,
                    "label": "Tickled"
                },
                {
                    "value": 245,
                    "label": "Hot"
                },
                {
                    "value": 246,
                    "label": "Cold"
                },
                {
                    "value": 247,
                    "label": "Sweating"
                },
                {
                    "value": 248,
                    "label": "Warm"
                }
            ],
            //"response": null
        }
    ],
    "tasks": [
        {
            "id": 45,
            "question": "A person who feels <b>contempt</b> is actually feeling a combination of which <b><u>two</u></b> emotions?",
            "description": "",
            "numberOfResponses": 2,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 189,
                    "label": "Anger"
                },
                {
                    "value": 190,
                    "label": "Disgust"
                },
                {
                    "value": 191,
                    "label": "Frustration"
                },
                {
                    "value": 192,
                    "label": "Sadness"
                },
                {
                    "value": 193,
                    "label": "Surprise"
                },
                {
                    "value": 194,
                    "label": "Tolerance"
                }
            ],
            //"response": null
        },
        {
            "id": 46,
            "question": "A person who feels <b>optimism</b> is actually feeling a combination of which <b><u>two</u></b> emotions?",
            "description": "",
            "numberOfResponses": 2,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 195,
                    "label": "Anger"
                },
                {
                    "value": 196,
                    "label": "Anticipation"
                },
                {
                    "value": 197,
                    "label": "Apprehension"
                },
                {
                    "value": 198,
                    "label": "Joy"
                },
                {
                    "value": 199,
                    "label": "Love"
                },
                {
                    "value": 200,
                    "label": "Exhilaration"
                }
            ],
            //"response": null
        },
        {
            "id": 47,
            "question": "A person who feels <b>nostalgia</b> is actually feeling a combination of which <b><u>two</u></b> emotions?",
            "description": "",
            "numberOfResponses": 2,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 201,
                    "label": "Affection"
                },
                {
                    "value": 202,
                    "label": "Anger"
                },
                {
                    "value": 203,
                    "label": "Disappointment"
                },
                {
                    "value": 204,
                    "label": "Fear"
                },
                {
                    "value": 205,
                    "label": "Sadness"
                },
                {
                    "value": 206,
                    "label": "Serenity"
                }
            ],
            //"response": null
        },
        {
            "id": 48,
            "question": "A person who feels <b>submissiveness</b> is actually feeling a combination of which <b><u>two</u></b> emotions?",
            "description": "",
            "numberOfResponses": 2,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 207,
                    "label": "Annoyance"
                },
                {
                    "value": 208,
                    "label": "Boredom"
                },
                {
                    "value": 209,
                    "label": "Fear"
                },
                {
                    "value": 210,
                    "label": "Disgust"
                },
                {
                    "value": 211,
                    "label": "Sadness"
                },
                {
                    "value": 212,
                    "label": "Trust"
                }
            ],
            //"response": null
        },
        {
            "id": 49,
            "question": "A person who feels <b>love</b> is actually feeling a combination of which <b><u>two</u></b> emotions?",
            "description": "",
            "numberOfResponses": 2,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 213,
                    "label": "Fear"
                },
                {
                    "value": 214,
                    "label": "Frustration"
                },
                {
                    "value": 215,
                    "label": "Happiness"
                },
                {
                    "value": 216,
                    "label": "Surprise"
                },
                {
                    "value": 217,
                    "label": "Trust"
                },
                {
                    "value": 218,
                    "label": "Uncertainty"
                }
            ],
            //"response": null
        },
        {
            "id": 50,
            "question": "A person who feels <b>remorse</b> is actually feeling a combination of which <b><u>two</u></b> emotions?",
            "description": "",
            "numberOfResponses": 2,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 219,
                    "label": "Disgust"
                },
                {
                    "value": 220,
                    "label": "Apprehension"
                },
                {
                    "value": 221,
                    "label": "Anger"
                },
                {
                    "value": 222,
                    "label": "Dismay"
                },
                {
                    "value": 223,
                    "label": "Sadness"
                },
                {
                    "value": 224,
                    "label": "Uncertainty"
                }
            ],
            //"response": null
        },
        {
            "id": 51,
            "question": "A person who feels <b>awe</b> is actually feeling a combination of which <b><u>two</u></b> emotions?",
            "description": "",
            "numberOfResponses": 2,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 225,
                    "label": "Anger"
                },
                {
                    "value": 226,
                    "label": "Boredom"
                },
                {
                    "value": 227,
                    "label": "Calmness"
                },
                {
                    "value": 228,
                    "label": "Fear"
                },
                {
                    "value": 229,
                    "label": "Sadness"
                },
                {
                    "value": 230,
                    "label": "Surprise"
                }
            ],
            //"response": null
        },
        {
            "id": 52,
            "question": "A person who feels <b>concern</b> is actually feeling a combination of which <b><u>three</u></b> emotions?",
            "description": "",
            "numberOfResponses": 3,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 231,
                    "label": "Anger"
                },
                {
                    "value": 232,
                    "label": "Anticipation"
                },
                {
                    "value": 233,
                    "label": "Anxiety"
                },
                {
                    "value": 234,
                    "label": "Caring"
                },
                {
                    "value": 235,
                    "label": "Dislike"
                },
                {
                    "value": 236,
                    "label": "Surprise"
                }
            ],
            //"response": null
        },
        {
            "id": 53,
            "question": "A person who feels <b>calmness</b> is actually feeling a combination of which <b><u>three</u></b> emotions?",
            "description": "",
            "numberOfResponses": 3,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 237,
                    "label": "Serenity"
                },
                {
                    "value": 238,
                    "label": "Delight"
                },
                {
                    "value": 239,
                    "label": "Expectancy"
                },
                {
                    "value": 240,
                    "label": "Relaxation"
                },
                {
                    "value": 241,
                    "label": "Security"
                },
                {
                    "value": 242,
                    "label": "Anticipation"
                }
            ],
            //"response": null
        }
    ]
}

const progressionsEnergyTasks = {
    "id": 7,
    "name": "ProgressionsEnergy",
    "rank": 9,
    "practice": [
        {
            "id": 55,
            "question": "Rank <b>the energy</b> of these emotions in order from <b>most to least energy.</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 2,
            "mediaPath": [],
            "options": [
                {
                    "value": 249,
                    "label": "Hate"
                },
                {
                    "value": 250,
                    "label": "Disgust"
                },
                {
                    "value": 251,
                    "label": "Dislike"
                },
                {
                    "value": 252,
                    "label": "Indifferent"
                },
                {
                    "value": 253,
                    "label": "Despise"
                }
            ],
            //"response": null
        }
    ],
    "attention": [],
    "tasks": [
        {
            "id": 56,
            "question": "Rank the <b>energy</b> of these emotions in order from <b>most to least energy:</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 2,
            "mediaPath": [],
            "options": [
                {
                    "value": 254,
                    "label": "Content"
                },
                {
                    "value": 255,
                    "label": "Ecstatic"
                },
                {
                    "value": 256,
                    "label": "Amused"
                },
                {
                    "value": 257,
                    "label": "Jubilant"
                },
                {
                    "value": 258,
                    "label": "Delighted"
                }
            ],
            //"response": null
        },
        {
            "id": 57,
            "question": "Rank the <b>energy</b> of these emotions in order from <b>most to least energy:</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 2,
            "mediaPath": [],
            "options": [
                {
                    "value": 259,
                    "label": "Miserable"
                },
                {
                    "value": 260,
                    "label": "Sad"
                },
                {
                    "value": 261,
                    "label": "Bored"
                },
                {
                    "value": 262,
                    "label": "Depressed"
                },
                {
                    "value": 263,
                    "label": "Gloomy"
                }
            ],
            //"response": null
        },
        {
            "id": 58,
            "question": "Rank the <b>energy</b> of these emotions in order from <b>most to least energy:</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 2,
            "mediaPath": [],
            "options": [
                {
                    "value": 264,
                    "label": "Dislike"
                },
                {
                    "value": 265,
                    "label": "Appalled"
                },
                {
                    "value": 266,
                    "label": "Repulsed"
                },
                {
                    "value": 267,
                    "label": "Disgusted"
                },
                {
                    "value": 268,
                    "label": "Offended"
                }
            ],
            //"response": null
        },
        {
            "id": 59,
            "question": "Rank the <b>energy</b> of these emotions in order from <b>most to least energy:</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 2,
            "mediaPath": [],
            "options": [
                {
                    "value": 269,
                    "label": "Satisfied"
                },
                {
                    "value": 270,
                    "label": "Peaceful"
                },
                {
                    "value": 271,
                    "label": "Glad"
                },
                {
                    "value": 272,
                    "label": "Pleased"
                },
                {
                    "value": 273,
                    "label": "Excited"
                }
            ],
            //"response": null
        },
        {
            "id": 60,
            "question": "Rank the <b>energy</b> of these emotions in order from <b>most to least energy:</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 2,
            "mediaPath": [],
            "options": [
                {
                    "value": 274,
                    "label": "Displeased"
                },
                {
                    "value": 275,
                    "label": "Angry"
                },
                {
                    "value": 276,
                    "label": "Frustrated"
                },
                {
                    "value": 277,
                    "label": "Annoyed"
                },
                {
                    "value": 278,
                    "label": "Furious"
                }
            ],
            //"response": null
        },
        {
            "id": 61,
            "question": "Rank the <b>energy</b> of these emotions in order from <b>most to least energy:</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 2,
            "mediaPath": [],
            "options": [
                {
                    "value": 279,
                    "label": "Adore"
                },
                {
                    "value": 280,
                    "label": "Like"
                },
                {
                    "value": 281,
                    "label": "Interested"
                },
                {
                    "value": 282,
                    "label": "Care"
                },
                {
                    "value": 283,
                    "label": "Love"
                }
            ],
            //"response": null
        },
        {
            "id": 62,
            "question": "Rank the <b>energy</b> of these emotions in order from <b>most to least energy:</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 2,
            "mediaPath": [],
            "options": [
                {
                    "value": 284,
                    "label": "Uncomfortable"
                },
                {
                    "value": 285,
                    "label": "Terrified"
                },
                {
                    "value": 286,
                    "label": "Anxious"
                },
                {
                    "value": 287,
                    "label": "Alarmed"
                },
                {
                    "value": 288,
                    "label": "Afraid"
                }
            ],
            //"response": null
        },
        {
            "id": 63,
            "question": "Rank the <b>energy</b> of these emotions in order from <b>most to least energy:</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 2,
            "mediaPath": [],
            "options": [
                {
                    "value": 289,
                    "label": "Ashamed"
                },
                {
                    "value": 290,
                    "label": "Embarrassed"
                },
                {
                    "value": 291,
                    "label": "Mortified"
                },
                {
                    "value": 292,
                    "label": "Humiliated"
                },
                {
                    "value": 293,
                    "label": "Insecure"
                }
            ],
            //"response": null
        }
    ]
}

const progressionsPleasantTasks = {
    "id": 8,
    "name": "ProgressionsPleasant",
    "rank": 10,
    "practice": [
        {
            "id": 64,
            "question": "Rank the <b>pleasantness</b> of these emotions in order from most to least pleasant:",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 1,
            "mediaPath": [],
            "options": [
                {
                    "value": 294,
                    "label": "Happy"
                },
                {
                    "value": 295,
                    "label": "Astonished"
                },
                {
                    "value": 296,
                    "label": "Disappointed"
                },
                {
                    "value": 297,
                    "label": "Excited"
                },
                {
                    "value": 298,
                    "label": "Bored"
                }
            ],
            //"response": null
        }
    ],
    "attention": [
        {
            "id": 69,
            "question": "Rank order the<b>emotion words</b> below from <b>most to least number of letters:</b>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 1,
            "mediaPath": [],
            "options": [
                {
                    "value": 319,
                    "label": "Excited"
                },
                {
                    "value": 320,
                    "label": "Calm"
                },
                {
                    "value": 321,
                    "label": "Astonished"
                },
                {
                    "value": 322,
                    "label": "Bored"
                },
                {
                    "value": 323,
                    "label": "Sad"
                }
            ],
            //"response": null
        }
    ],
    "tasks": [
        {
            "id": 65,
            "question": "Rank the <b>pleasantness</b> of these emotions in order from most to least pleasant:",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 1,
            "mediaPath": [],
            "options": [
                {
                    "value": 299,
                    "label": "Tense"
                },
                {
                    "value": 300,
                    "label": "Sleepy"
                },
                {
                    "value": 301,
                    "label": "Content"
                },
                {
                    "value": 302,
                    "label": "Miserable"
                },
                {
                    "value": 303,
                    "label": "Calm"
                }
            ],
            //"response": null
        },
        {
            "id": 66,
            "question": "Rank the <b>pleasantness</b> of these emotions in order from most to least pleasant:",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 1,
            "mediaPath": [],
            "options": [
                {
                    "value": 304,
                    "label": "Enraged"
                },
                {
                    "value": 305,
                    "label": "Relaxed"
                },
                {
                    "value": 306,
                    "label": "Distracted"
                },
                {
                    "value": 307,
                    "label": "Angry"
                },
                {
                    "value": 308,
                    "label": "Irritated"
                }
            ],
            //"response": null
        },
        {
            "id": 67,
            "question": "Rank the <b>pleasantness</b> of these emotions in order from most to least pleasant:",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 1,
            "mediaPath": [],
            "options": [
                {
                    "value": 309,
                    "label": "Serene"
                },
                {
                    "value": 310,
                    "label": "Pleased"
                },
                {
                    "value": 311,
                    "label": "Sleepy"
                },
                {
                    "value": 312,
                    "label": "Happy"
                },
                {
                    "value": 313,
                    "label": "Calm"
                }
            ],
            //"response": null
        },
        {
            "id": 68,
            "question": "Rank the <b>pleasantness</b> of these emotions in order from most to least pleasant:",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": 1,
            "mediaPath": [],
            "options": [
                {
                    "value": 314,
                    "label": "Frightened"
                },
                {
                    "value": 315,
                    "label": "Hopeful"
                },
                {
                    "value": 316,
                    "label": "Uneasy"
                },
                {
                    "value": 317,
                    "label": "Concerned"
                },
                {
                    "value": 318,
                    "label": "Surprised"
                }
            ],
            //"response": null
        }
    ]
}

const comicStripsTasks = {
    "id": 9,
    "name": "ComicStrips",
    "rank": 8,
    "practice": [
        {
            "id": 70,
            "question": "<u>In which situation would the man feel <b>most calm</b>?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Practice.png"
            ],
            "options": [
                {
                    "value": 324,
                    "label": "The coworker says, “I’m sorry to hear you were in an accident, but maybe the other driver was rushing because of an emergency.”"
                },
                {
                    "value": 325,
                    "label": "The coworker says, “That’s awful, anyone would feel upset in your situation.”"
                },
                {
                    "value": 326,
                    "label": "The coworker asks, “What are you feeling right now? Why do you feel like this?”"
                },
                {
                    "value": 327,
                    "label": "The coworker says, “Even though your car was damaged, at least you weren’t injured.”"
                }
            ],
            "response": null
        }
    ],
    "attention": [
        {
            "id": 83,
            "question": "<u>What is this story about?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Attention.png"
            ],
            "options": [
                {
                    "value": 376,
                    "label": "A sports team playing a game."
                },
                {
                    "value": 377,
                    "label": "A teacher going to school."
                },
                {
                    "value": 378,
                    "label": "A movie about a lost dog."
                },
                {
                    "value": 379,
                    "label": "A family is expecting another child."
                }
            ],
            "response": null
        }
    ],
    "tasks": [
        {
            "id": 71,
            "question": "<u>What could the friend say to make the woman feel <b>least frightened</b>?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item1.png"
            ],
            "options": [
                {
                    "value": 328,
                    "label": "“Try not to think about it; you can’t control it, so you’ll just have to wait.” "
                },
                {
                    "value": 329,
                    "label": "“Nothing’s definite yet; let’s wait for more information. Want to have lunch at that new restaurant?” "
                },
                {
                    "value": 330,
                    "label": "“How did that conversation with your doctor make you feel?” "
                },
                {
                    "value": 331,
                    "label": "“I can understand that you’re worried, but this is very common; my sister had to have more tests done.”"
                }
            ],
            "response": null
        },
        {
            "id": 72,
            "question": "<u>What could the friend say to <b>lower the woman’s optimism for a positive</b> outcome?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item1.png"
            ],
            "options": [
                {
                    "value": 332,
                    "label": "“Didn’t your grandmother pass away due to a hereditary heart condition? Your symptoms sound like hers. Are you worried?”"
                },
                {
                    "value": 333,
                    "label": "“No matter what happens, I’ll be there to support you.” "
                },
                {
                    "value": 334,
                    "label": "“It is unfortunate the doctor couldn’t give you more definite information.” "
                },
                {
                    "value": 335,
                    "label": "“There’s nothing you can do about it right now, so try not to think about it.”"
                }
            ],
            "response": null
        },
        {
            "id": 73,
            "question": "<u>The friend feels helpless because she is unable to provide more support to the woman. In which situation would the woman’s friend feel <b>least helpless</b>?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item1.png"
            ],
            "options": [
                {
                    "value": 336,
                    "label": "The woman says to her friend, “Thank you for listening to me. I really value your friendship.” "
                },
                {
                    "value": 337,
                    "label": "The woman says to her friend, “This news is unexpected for both of us. How do you feel right now?”"
                },
                {
                    "value": 338,
                    "label": "The woman says to her friend, “It’s normal to feel uncertain in this kind of situation.” "
                },
                {
                    "value": 339,
                    "label": "The woman impatiently brushes off her friend’s attempt to comfort her."
                }
            ],
            "response": null
        },
        {
            "id": 74,
            "question": "<u>In which situation would the man feel <b>most eager</b> to give the presentation?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item2.png"
            ],
            "options": [
                {
                    "value": 340,
                    "label": "The manager says, “This presentation will be a great opportunity for you to get feedback from other managers about your ideas.” "
                },
                {
                    "value": 341,
                    "label": "The manager says, “You tend to talk faster when you’re nervous. Remember to slow down when you present.” "
                },
                {
                    "value": 342,
                    "label": "The manager says, “Your dry run the other day was excellent, and you’ve really mastered the material. Relax, remember to smile, and share some of your enthusiasm!”"
                },
                {
                    "value": 343,
                    "label": "The manager says, “Since we have a few minutes before the presentation starts, let’s talk about the work that you submitted to me yesterday.”  "
                }
            ],
            "response": null
        },
        {
            "id": 75,
            "question": "<u>In which situation would the man feel <b>most anxious</b> about giving the presentation?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item2.png"
            ],
            "options": [
                {
                    "value": 344,
                    "label": "The manager says, “You’re great at public speaking. I’m looking forward to this presentation!” "
                },
                {
                    "value": 345,
                    "label": "The manager says, “Remember, we’re really on the line with this project, and senior management will be watching. We won’t be able to move forward unless this presentation is good, so good luck.”"
                },
                {
                    "value": 346,
                    "label": "The manager says, “If you need my support at any time during the presentation, don’t hesitate to call on me.” "
                },
                {
                    "value": 347,
                    "label": "The manager says, “My presentations are usually well-received, but others find it hard presenting to this group of people.” "
                }
            ],
            "response": null
        },
        {
            "id": 76,
            "question": "<u>What could the employee say to <b>gain his manager’s confidence</b>?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item2.png"
            ],
            "options": [
                {
                    "value": 348,
                    "label": "“Thank you for reviewing my presentation notes yesterday; I really value your feedback.” "
                },
                {
                    "value": 349,
                    "label": "“I included all of the important information in the presentation, but it might be too long now.”"
                },
                {
                    "value": 350,
                    "label": "“I feel certain that between your guidance and my preparation, this presentation will go well.” "
                },
                {
                    "value": 351,
                    "label": "The employee says nothing to his manager; he is too busy reviewing his presentation notes. "
                }
            ],
            "response": null
        },
        {
            "id": 77,
            "question": "<u>In which situation would the man feel <b>least frustrated</b> over the additional delay?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item3.png"
            ],
            "options": [
                {
                    "value": 352,
                    "label": "The man calls home to say how frustrated he is. "
                },
                {
                    "value": 353,
                    "label": "The man realizes that the delays won’t affect his trip’s schedule that much. "
                },
                {
                    "value": 354,
                    "label": "The man tries to forget the delay, and instead watches an uninteresting online video. "
                },
                {
                    "value": 355,
                    "label": "The man realizes that the delay gives him extra time to complete some work on his laptop."
                }
            ],
            "response": null
        },
        {
            "id": 78,
            "question": "<u>In which situation would the man feel <b>least concerned</b> about the delay?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item3.png"
            ],
            "options": [
                {
                    "value": 356,
                    "label": "The man uses the extra time to catch up on his emails. "
                },
                {
                    "value": 357,
                    "label": "The man uses the extra time at the airport to rearrange his schedule based on the new delay. "
                },
                {
                    "value": 358,
                    "label": "The man goes to the airline counter to find out more information about the delay. "
                },
                {
                    "value": 359,
                    "label": "The man tells himself that the situation is out of his control, and to stop worrying about it."
                }
            ],
            "response": null
        },
        {
            "id": 79,
            "question": "<u>In which situation would the man feel <b>least accepting</b> of the delay?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item3.png"
            ],
            "options": [
                {
                    "value": 360,
                    "label": "The man remembers being delayed the last time he traveled with this airline and questions the airline’s overall competence."
                },
                {
                    "value": 361,
                    "label": "The man thinks about the time he’s already spent waiting at the airport before this additional inconvenience. "
                },
                {
                    "value": 362,
                    "label": "The man decides to go buy something to eat but ends up eating too much. "
                },
                {
                    "value": 363,
                    "label": "The man tries to hide how annoyed he is by the additional delay. "
                }
            ],
            "response": null
        },
        {
            "id": 80,
            "question": "<u>In which situation would the woman feel <b>least nervous</b> about the tight deadline?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item4.png"
            ],
            "options": [
                {
                    "value": 364,
                    "label": "The woman takes deep breaths to reduce her anxiety about the timeline. "
                },
                {
                    "value": 365,
                    "label": "The woman thinks to herself, “I was assigned this project because my manager is confident in my ability to complete it on time.” "
                },
                {
                    "value": 366,
                    "label": "The woman tells herself to stop thinking about the tight deadline and instead starts listing the tasks that need to be completed for the project."
                },
                {
                    "value": 367,
                    "label": "The woman decides to take a coffee break. "
                }
            ],
            "response": null
        },
        {
            "id": 81,
            "question": "<u>In which situation would the woman feel <b>least resentful</b> about being assigned the new project?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item4.png"
            ],
            "options": [
                {
                    "value": 368,
                    "label": "The woman thinks about the large impact that this new project will have on her already heavy workload. "
                },
                {
                    "value": 369,
                    "label": "The woman sets the project aside for now and continues working on tasks with more immediate deadlines. "
                },
                {
                    "value": 370,
                    "label": "The woman realizes that the project is simpler than she originally thought, and so it won’t take her as much time to complete."
                },
                {
                    "value": 371,
                    "label": "The woman tries not to think about how busy she will be over the next two weeks. "
                }
            ],
            "response": null
        },
        {
            "id": 82,
            "question": "<u>In which situation would the woman feel <b>least frustrated</b> over her heavy workload?</u>",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/comicstrips/Item4.png"
            ],
            "options": [
                {
                    "value": 372,
                    "label": "The woman tries not to think about all of the overtime that she has already put in. "
                },
                {
                    "value": 373,
                    "label": "The woman envisions how grateful people will be when she completes the project on time, and smiles in front of her coworkers to hide any momentary frustration."
                },
                {
                    "value": 374,
                    "label": "The woman reluctantly accepts the project and tries not to show her frustration over her increased workload. "
                },
                {
                    "value": 375,
                    "label": "The woman tries not to think about the extra work she’ll have to complete in the upcoming two weeks."
                }
            ],
            "response": null
        }
    ]
}

const videosTasks = {
    "id": 10,
    "name": "videosTasks",
    "rank": 13,
    "practice": [
        {
            "id": 84,
            "question": "Which emotion is best expressed by the person in this video?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/videos/PracticeItem.mp4"
            ],
            "options": [
                {
                    "value": 380,
                    "label": "Uncertainty"
                },
                {
                    "value": 381,
                    "label": "Disgust "
                },
                {
                    "value": 382,
                    "label": "Sadness"
                },
                {
                    "value": 383,
                    "label": "Confusion"
                }
            ],
            "response": null
        },
        {
            "id": 85,
            "question": "Which emotion is best expressed by the person in this video?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/videos/Item5.mp4"
            ],
            "options": [
                {
                    "value": 384,
                    "label": "Anger"
                },
                {
                    "value": 385,
                    "label": "Anticipation"
                },
                {
                    "value": 386,
                    "label": "Anxiety"
                },
                {
                    "value": 387,
                    "label": "Surprise"
                }
            ],
            "response": null
        },
        {
            "id": 86,
            "question": "Which emotion is best expressed by the person in this video?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/videos/Item6.mp4"
            ],
            "options": [
                {
                    "value": 388,
                    "label": "Anger"
                },
                {
                    "value": 389,
                    "label": "Annoyance"
                },
                {
                    "value": 390,
                    "label": "Contempt"
                },
                {
                    "value": 391,
                    "label": "Confusion"
                }
            ],
            "response": null
        }
    ],
    "attention": [],
    "tasks": [
        {
            "id": 87,
            "question": "Which emotion is best expressed by the person in this video?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/videos/Item1.mp4"
            ],
            "options": [
                {
                    "value": 392,
                    "label": "Excitement"
                },
                {
                    "value": 393,
                    "label": "Nervousness"
                },
                {
                    "value": 394,
                    "label": "Astonishment"
                },
                {
                    "value": 395,
                    "label": "Happiness"
                }
            ],
            "response": null
        },
        {
            "id": 88,
            "question": "Which emotion is best expressed by the person in this video?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/videos/Item4.mp4"
            ],
            "options": [
                {
                    "value": 396,
                    "label": "Anticipation"
                },
                {
                    "value": 397,
                    "label": "Frustration"
                },
                {
                    "value": 398,
                    "label": "Fear"
                },
                {
                    "value": 399,
                    "label": "Surprise"
                }
            ],
            "response": null
        },
        {
            "id": 89,
            "question": "Which emotion is best expressed by the person in this video?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/videos/Item8.mp4"
            ],
            "options": [
                {
                    "value": 400,
                    "label": "Smugness"
                },
                {
                    "value": 401,
                    "label": "Happiness"
                },
                {
                    "value": 402,
                    "label": "Contempt"
                },
                {
                    "value": 403,
                    "label": "Disgust"
                }
            ],
            "response": null
        },
        {
            "id": 90,
            "question": "Which emotion is best expressed by the person in this video?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/videos/Item9.mp4"
            ],
            "options": [
                {
                    "value": 404,
                    "label": "Anger"
                },
                {
                    "value": 405,
                    "label": "Sadness"
                },
                {
                    "value": 406,
                    "label": "Shame"
                },
                {
                    "value": 407,
                    "label": "Frustration"
                }
            ],
            "response": null
        },
        {
            "id": 91,
            "question": "Which emotion is best expressed by the person in this video?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/videos/Item11.mp4"
            ],
            "options": [
                {
                    "value": 408,
                    "label": "Annoyance"
                },
                {
                    "value": 409,
                    "label": "Anger"
                },
                {
                    "value": 410,
                    "label": "Confusion"
                },
                {
                    "value": 411,
                    "label": "Contempt"
                }
            ],
            "response": null
        }
    ]
}

const textScenariosTasks = {
    "id": 11,
    "name": "TextScenarios",
    "rank": 4,
    "practice": [
        {
            "id": 92,
            "question": "<u>In which situation would Hector feel <b>least hurt</b> in response to his friend’s sudden announcement?</u>",
            "description": "Hector developed a close friendship at work over the last year. Today, that friend surprised him by saying he had taken a job at another company and would be moving out of the area.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 412,
                    "label": "Hector goes and socializes with other friends at work."
                },
                {
                    "value": 413,
                    "label": "Hector tells himself that it is more important for him to get his work done, and to stop thinking about it."
                },
                {
                    "value": 414,
                    "label": "Hector thinks about how he feels about this news, and decides to speak to his friend about it."
                },
                {
                    "value": 415,
                    "label": "Hector assumes that his friend does not care for him; after all, the friend said nothing about searching for new jobs."
                }
            ],
            "response": null
        }
    ],
    "attention": [],
    "tasks": [
        {
            "id": 93,
            "question": "<u>In which situation would Amir feel the <b>least desire</b> to purchase the jacket?</u>",
            "description": "While in a clothing store, Amir saw a jacket that he might want to buy. He asked the salesperson a few questions about the jacket, but the salesperson's responses were impatient and curt.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 416,
                    "label": "The salesperson says, “I’m really busy right now; if you want to buy the jacket, do it quickly.”"
                },
                {
                    "value": 417,
                    "label": "After answering Amir’s questions, the salesperson walks away without offering additional assistance."
                },
                {
                    "value": 418,
                    "label": "The salesperson asks, “Are you buying this for a special occasion? Can you tell me what you’re looking for?”"
                },
                {
                    "value": 419,
                    "label": "The salesperson says, “This jacket usually looks better on tall people like me.”"
                }
            ],
            "response": null
        },
        {
            "id": 94,
            "question": "<u>In which situation would Amir feel <b>least angry</b> over the salesperson’s poor customer service attitude?</u>",
            "description": "While in a clothing store, Amir saw a jacket that he might want to buy. He asked the salesperson a few questions about the jacket, but the salesperson's responses were impatient and curt.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 420,
                    "label": "The salesperson says, “I’m sorry for my tone. It’s been a really difficult day. Do you have any other questions?”"
                },
                {
                    "value": 421,
                    "label": "The salesperson says, “I think this jacket suits your style, would you like to try it on?”"
                },
                {
                    "value": 422,
                    "label": "While walking way, the salesperson says, “Sorry, I’m busy right now, try asking one of my coworkers.”"
                },
                {
                    "value": 423,
                    "label": "The salesperson says, “This jacket is quite pricey, maybe you should look around a bit more.”"
                }
            ],
            "response": null
        },
        {
            "id": 95,
            "question": "<u>In which situation would the salesperson feel <b>least apathetic</b>?</u> ",
            "description": "While in a clothing store, Amir saw a jacket that he might want to buy. He asked the salesperson a few questions about the jacket, but the salesperson's responses were impatient and curt.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 424,
                    "label": "Amir says, “I see you are busy, so thank you for taking the time to answer my questions.”"
                },
                {
                    "value": 425,
                    "label": "Amir says, “I was thinking of buying this jacket, but I won’t buy it now because you were so rude.”"
                },
                {
                    "value": 426,
                    "label": "After the salesperson finishes speaking, Amir quickly leaves the store without making the purchase."
                },
                {
                    "value": 427,
                    "label": "Amir feels the salesperson's attitude was unacceptable and asks to speak with the store manager."
                }
            ],
            "response": null
        },
        {
            "id": 96,
            "question": "<u>In which situation would Roy feel <b>most disappointed</b> about not being promoted?</u>",
            "description": "Roy has been working for the same company for ten years and always received excellent performance reviews. He believes he has a reasonable chance of being promoted into a newly created director's position, even though the company’s stated policy is to consider both internal and external candidates for important positions. When he hears that the position had been filled by an external hire, Roy confides to a close friend who works at another firm.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 428,
                    "label": "Roy's friend says, “It’s their loss. Given your experience and history with the company, you would have been perfect for the position.”"
                },
                {
                    "value": 429,
                    "label": "Roy's friend says, “You are qualified, but maybe the executives want to bring new perspectives into the company.”"
                },
                {
                    "value": 430,
                    "label": "Roy's friend says, “I know you’re disappointed, but it’s partly your own fault. You need to take more initiative instead of waiting for these opportunities to be handed to you.”"
                },
                {
                    "value": 431,
                    "label": "Roy's friend says, “It seems your company doesn't value your contributions. You’ve been working there for a decade and they haven’t promoted you or recognized you in any other way.”"
                }
            ],
            "response": null
        },
        {
            "id": 97,
            "question": "<u>In which situation would Roy feel <b>most hopeful</b> about his future with this company?</u>",
            "description": "Roy has been working for the same company for ten years and always received excellent performance reviews. He believes he has a reasonable chance of being promoted into a newly created director's position, even though the company’s stated policy is to consider both internal and external candidates for important positions. When he hears that the position had been filled by an external hire, Roy confides to a close friend who works at another firm.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 432,
                    "label": "Roy's friend says, “It's too bad that you weren't promoted, but your company is growing quickly. There'll be other future opportunities—and they do sometimes hire from within.”"
                },
                {
                    "value": 433,
                    "label": "Roy's friend says, “You must be so disappointed. Do you want to talk about it?”"
                },
                {
                    "value": 434,
                    "label": "Roy's friend says, “It's too bad that things didn't work out, but you’re so talented; I’m sure you’ll be recognized at some point.”"
                },
                {
                    "value": 435,
                    "label": "Roy's friend says, “There’s nothing you can do to change their decision. Let’s go out and have some fun instead.”"
                }
            ],
            "response": null
        },
        {
            "id": 98,
            "question": "<u>In which situation would Roy elicit the <b>most comfort</b> from his friend?</u>",
            "description": "Roy has been working for the same company for ten years and always received excellent performance reviews. He believes he has a reasonable chance of being promoted into a newly created director's position, even though the company’s stated policy is to consider both internal and external candidates for important positions. When he hears that the position had been filled by an external hire, Roy confides to a close friend who works at another firm.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 436,
                    "label": "Roy says, “I know this could have happened to anyone, but I’m finding it very hard to swallow. Was it me? Do you think they respect me and my work?”"
                },
                {
                    "value": 437,
                    "label": "Roy says, “I work so hard, and I have done everything I can to show them that I’m leadership material. If they don’t see it, that’s their problem. I can’t believe how small-minded they are.”"
                },
                {
                    "value": 438,
                    "label": "Roy says, “It’s so unfair. You can’t get anywhere in this company unless you are friends with the right people.”"
                },
                {
                    "value": 439,
                    "label": "Roy says, “You’re so lucky that the career opportunities at your company are so transparent.”"
                }
            ],
            "response": null
        },
        {
            "id": 99,
            "question": "<u>In which situation would the woman feel <b>least anxious</b> about not being truthful?</u>",
            "description": "An employee’s manager praises her for coming up with an innovative new marketing strategy. Even though it was her coworker who thought of the marketing strategy, the woman accepts her manager's praise.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 440,
                    "label": "The woman tries not to think about what would happen if her manager found out that she wasn’t truthful."
                },
                {
                    "value": 441,
                    "label": "The woman tells herself not to worry, trying to suppress her anxiety."
                },
                {
                    "value": 442,
                    "label": "The woman tries not to think about how her relationship with her coworker may be affected by her actions."
                },
                {
                    "value": 443,
                    "label": "The woman joins a fun conversation so that she doesn’t appear to be anxious."
                }
            ],
            "response": null
        },
        {
            "id": 100,
            "question": "<u>In which situation would the woman feel <b>least guilty</b> about taking credit for someone else’s idea?</u>",
            "description": "An employee’s manager praises her for coming up with an innovative new marketing strategy. Even though it was her coworker who thought of the marketing strategy, the woman accepts her manager's praise.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 444,
                    "label": "The woman acknowledges that she feels bad about what she did and wonders why she wasn’t truthful with her manager."
                },
                {
                    "value": 445,
                    "label": "The woman tells herself that she didn’t really lie, since the coworker came up with the idea during a joint brainstorming session."
                },
                {
                    "value": 446,
                    "label": "The woman decides to avoid her coworker and her manager while in the office."
                },
                {
                    "value": 447,
                    "label": "The woman goes out of her way to help her team throughout the rest of the day."
                }
            ],
            "response": null
        },
        {
            "id": 101,
            "question": "<u>In which situation would the woman feel <b>least satisfied</b> over being praised by her manager?</u>",
            "description": "An employee’s manager praises her for coming up with an innovative new marketing strategy. Even though it was her coworker who thought of the marketing strategy, the woman accepts her manager's praise.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 448,
                    "label": "The woman quietly accepts her manager’s praise and then calmly goes about her work."
                },
                {
                    "value": 449,
                    "label": "The woman thinks about how good she felt when her manager praised her."
                },
                {
                    "value": 450,
                    "label": "The woman decides to take a break and enjoy the sunny weather outside."
                },
                {
                    "value": 451,
                    "label": "The woman wonders whether she should share her manager’s praise with her coworker."
                }
            ],
            "response": null
        },
        {
            "id": 102,
            "question": "<u>In which situation would Diana feel <b>most nervous</b> about being a new homeowner?</u>",
            "description": "Diana is ready to purchase her first house and her friend offers to go with her to view some possibilities. Several weekends are spent viewing houses before Diana finds and purchases what she considers her dream home.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 452,
                    "label": "Diana tells herself that the home she purchased is a good long-term investment."
                },
                {
                    "value": 453,
                    "label": "Diana realizes that she has reached a defining moment in adulthood by purchasing her home."
                },
                {
                    "value": 454,
                    "label": "Diana thinks about the additional costs and responsibilities that come with being a homeowner."
                },
                {
                    "value": 455,
                    "label": "Diana realizes that most new homeowners probably feel a bit nervous."
                }
            ],
            "response": null
        },
        {
            "id": 103,
            "question": "<u>In which situation would Diana feel the <b>most gratitude</b> toward her friend for accompanying her during the house hunting process?</u>",
            "description": "Diana is ready to purchase her first house and her friend offers to go with her to view some possibilities. Several weekends are spent viewing houses before Diana finds and purchases what she considers her dream home.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 456,
                    "label": "Diana thinks of all of the times that her friend had helped her out. "
                },
                {
                    "value": 457,
                    "label": "Diana tells her family about how her friend helped her during the house hunting process. "
                },
                {
                    "value": 458,
                    "label": "Diana realizes that her friend will probably ask her to return the favor in the future. "
                },
                {
                    "value": 459,
                    "label": "Diana thinks of all of the hassles that she went through the last time her friend asked her to repay a favor."
                }
            ],
            "response": null
        },
        {
            "id": 104,
            "question": "<u>In which situation would Diana feel <b>most impatient</b> to move into her new home?</u>",
            "description": "Diana is ready to purchase her first house and her friend offers to go with her to view some possibilities. Several weekends are spent viewing houses before Diana finds and purchases what she considers her dream home.",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 460,
                    "label": "Diana complains to her friend how the previous homeowner was unwilling to let Diana move in at the end of the month."
                },
                {
                    "value": 461,
                    "label": "Diana realizes that the time spent waiting to move into her new home could be spent hosting a party to say goodbye to her current neighbors."
                },
                {
                    "value": 462,
                    "label": "Diana thinks about how she will need to pay for another month’s rent on her present residence while she waits to move in."
                },
                {
                    "value": 463,
                    "label": "Diana reflects on how organized and prepared she is to move in."
                }
            ],
            "response": null
        }
    ]
}

const facesTasks = {
    "id": 12,
    "name": "Faces",
    "rank": 1,
    "practice": [
        {
            "id": 105,
            "question": "How much <b>happiness</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_PracticeItem_Neutral.png",
                "/images/faces/Faces_PracticeItem_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 464,
                    "label": "None"
                },
                {
                    "value": 465,
                    "label": "A little"
                },
                {
                    "value": 466,
                    "label": "Some"
                },
                {
                    "value": 467,
                    "label": "Moderate"
                },
                {
                    "value": 468,
                    "label": "A lot"
                },
                {
                    "value": 469,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 106,
            "question": "How much <b>embarassment</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_PracticeItem_Neutral.png",
                "/images/faces/Faces_PracticeItem_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 470,
                    "label": "None"
                },
                {
                    "value": 471,
                    "label": "A little"
                },
                {
                    "value": 472,
                    "label": "Some"
                },
                {
                    "value": 473,
                    "label": "Moderate"
                },
                {
                    "value": 474,
                    "label": "A lot"
                },
                {
                    "value": 475,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 107,
            "question": "How much <b>amusement</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_PracticeItem_Neutral.png",
                "/images/faces/Faces_PracticeItem_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 476,
                    "label": "None"
                },
                {
                    "value": 477,
                    "label": "A little"
                },
                {
                    "value": 478,
                    "label": "Some"
                },
                {
                    "value": 479,
                    "label": "Moderate"
                },
                {
                    "value": 480,
                    "label": "A lot"
                },
                {
                    "value": 481,
                    "label": "Extreme"
                }
            ],
            "response": null
        }
    ],
    "attention": [],
    "tasks": [
        {
            "id": 108,
            "question": "How much <b>anger</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item1_Neutral.png",
                "/images/faces/Faces_Item1_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 482,
                    "label": "None"
                },
                {
                    "value": 483,
                    "label": "A little"
                },
                {
                    "value": 484,
                    "label": "Some"
                },
                {
                    "value": 485,
                    "label": "Moderate"
                },
                {
                    "value": 486,
                    "label": "A lot"
                },
                {
                    "value": 487,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 109,
            "question": "How much <b>anxiety</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item1_Neutral.png",
                "/images/faces/Faces_Item1_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 488,
                    "label": "None"
                },
                {
                    "value": 489,
                    "label": "A little"
                },
                {
                    "value": 490,
                    "label": "Some"
                },
                {
                    "value": 491,
                    "label": "Moderate"
                },
                {
                    "value": 492,
                    "label": "A lot"
                },
                {
                    "value": 493,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 110,
            "question": "How much <b>irritation</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item1_Neutral.png",
                "/images/faces/Faces_Item1_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 494,
                    "label": "None"
                },
                {
                    "value": 495,
                    "label": "A little"
                },
                {
                    "value": 496,
                    "label": "Some"
                },
                {
                    "value": 497,
                    "label": "Moderate"
                },
                {
                    "value": 498,
                    "label": "A lot"
                },
                {
                    "value": 499,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 111,
            "question": "How much <b></b>contempt is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item2_Neutral.png",
                "/images/faces/Faces_Item2_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 501,
                    "label": "None"
                },
                {
                    "value": 502,
                    "label": "A little"
                },
                {
                    "value": 503,
                    "label": "Some"
                },
                {
                    "value": 504,
                    "label": "Moderate"
                },
                {
                    "value": 505,
                    "label": "A lot"
                },
                {
                    "value": 506,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 112,
            "question": "How much <b>anxiety</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item2_Neutral.png",
                "/images/faces/Faces_Item2_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 507,
                    "label": "None"
                },
                {
                    "value": 508,
                    "label": "A little"
                },
                {
                    "value": 509,
                    "label": "Some"
                },
                {
                    "value": 510,
                    "label": "Moderate"
                },
                {
                    "value": 511,
                    "label": "A lot"
                },
                {
                    "value": 512,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 113,
            "question": "How much <b>disgust</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item2_Neutral.png",
                "/images/faces/Faces_Item2_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 513,
                    "label": "None"
                },
                {
                    "value": 514,
                    "label": "A little"
                },
                {
                    "value": 515,
                    "label": "Some"
                },
                {
                    "value": 516,
                    "label": "Moderate"
                },
                {
                    "value": 517,
                    "label": "A lot"
                },
                {
                    "value": 518,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 114,
            "question": "How much <b>anger</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item3_Neutral.png",
                "/images/faces/Faces_Item3_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 519,
                    "label": "None"
                },
                {
                    "value": 520,
                    "label": "A little"
                },
                {
                    "value": 521,
                    "label": "Some"
                },
                {
                    "value": 522,
                    "label": "Moderate"
                },
                {
                    "value": 523,
                    "label": "A lot"
                },
                {
                    "value": 524,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 115,
            "question": "How much <b>surprise</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item3_Neutral.png",
                "/images/faces/Faces_Item3_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 525,
                    "label": "None"
                },
                {
                    "value": 526,
                    "label": "A little"
                },
                {
                    "value": 527,
                    "label": "Some"
                },
                {
                    "value": 528,
                    "label": "Moderate"
                },
                {
                    "value": 529,
                    "label": "A lot"
                },
                {
                    "value": 530,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 116,
            "question": "How much <b>loathing</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item3_Neutral.png",
                "/images/faces/Faces_Item3_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 531,
                    "label": "None"
                },
                {
                    "value": 532,
                    "label": "A little"
                },
                {
                    "value": 533,
                    "label": "Some"
                },
                {
                    "value": 534,
                    "label": "Moderate"
                },
                {
                    "value": 535,
                    "label": "A lot"
                },
                {
                    "value": 536,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 117,
            "question": "How much <b>contempt</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item4_Neutral.png",
                "/images/faces/Faces_Item4_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 537,
                    "label": "None"
                },
                {
                    "value": 538,
                    "label": "A little"
                },
                {
                    "value": 539,
                    "label": "Some"
                },
                {
                    "value": 540,
                    "label": "Moderate"
                },
                {
                    "value": 541,
                    "label": "A lot"
                },
                {
                    "value": 542,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 118,
            "question": "How much <b>happiness</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item4_Neutral.png",
                "/images/faces/Faces_Item4_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 543,
                    "label": "None"
                },
                {
                    "value": 544,
                    "label": "A little"
                },
                {
                    "value": 545,
                    "label": "Some"
                },
                {
                    "value": 546,
                    "label": "Moderate"
                },
                {
                    "value": 547,
                    "label": "A lot"
                },
                {
                    "value": 548,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 119,
            "question": "How much <b>irritation</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item4_Neutral.png",
                "/images/faces/Faces_Item4_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 549,
                    "label": "None"
                },
                {
                    "value": 550,
                    "label": "A little"
                },
                {
                    "value": 551,
                    "label": "Some"
                },
                {
                    "value": 552,
                    "label": "Moderate"
                },
                {
                    "value": 553,
                    "label": "A lot"
                },
                {
                    "value": 554,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 120,
            "question": "How much <b>surprise</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item6_Neutral.png",
                "/images/faces/Faces_Item6_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 555,
                    "label": "None"
                },
                {
                    "value": 556,
                    "label": "A little"
                },
                {
                    "value": 557,
                    "label": "Some"
                },
                {
                    "value": 558,
                    "label": "Moderate"
                },
                {
                    "value": 559,
                    "label": "A lot"
                },
                {
                    "value": 560,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 121,
            "question": "How much <b>concern</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item6_Neutral.png",
                "/images/faces/Faces_Item6_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 561,
                    "label": "None"
                },
                {
                    "value": 562,
                    "label": "A little"
                },
                {
                    "value": 563,
                    "label": "Some"
                },
                {
                    "value": 564,
                    "label": "Moderate"
                },
                {
                    "value": 565,
                    "label": "A lot"
                },
                {
                    "value": 566,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 122,
            "question": "How much <b>joy</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item6_Neutral.png",
                "/images/faces/Faces_Item6_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 567,
                    "label": "None"
                },
                {
                    "value": 568,
                    "label": "A little"
                },
                {
                    "value": 569,
                    "label": "Some"
                },
                {
                    "value": 570,
                    "label": "Moderate"
                },
                {
                    "value": 571,
                    "label": "A lot"
                },
                {
                    "value": 572,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 123,
            "question": "How much <b>disgust</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item7_Neutral.png",
                "/images/faces/Faces_Item7_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 573,
                    "label": "None"
                },
                {
                    "value": 574,
                    "label": "A little"
                },
                {
                    "value": 575,
                    "label": "Some"
                },
                {
                    "value": 576,
                    "label": "Moderate"
                },
                {
                    "value": 577,
                    "label": "A lot"
                },
                {
                    "value": 578,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 124,
            "question": "How much <b>fear</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item7_Neutral.png",
                "/images/faces/Faces_Item7_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 579,
                    "label": "None"
                },
                {
                    "value": 580,
                    "label": "A little"
                },
                {
                    "value": 581,
                    "label": "Some"
                },
                {
                    "value": 582,
                    "label": "Moderate"
                },
                {
                    "value": 583,
                    "label": "A lot"
                },
                {
                    "value": 584,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 125,
            "question": "How much <b>concern</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item7_Neutral.png",
                "/images/faces/Faces_Item7_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 585,
                    "label": "None"
                },
                {
                    "value": 586,
                    "label": "A little"
                },
                {
                    "value": 587,
                    "label": "Some"
                },
                {
                    "value": 588,
                    "label": "Moderate"
                },
                {
                    "value": 589,
                    "label": "A lot"
                },
                {
                    "value": 590,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 126,
            "question": "How much <b>disgust</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item8_Neutral.png",
                "/images/faces/Faces_Item8_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 591,
                    "label": "None"
                },
                {
                    "value": 592,
                    "label": "A little"
                },
                {
                    "value": 593,
                    "label": "Some"
                },
                {
                    "value": 594,
                    "label": "Moderate"
                },
                {
                    "value": 595,
                    "label": "A lot"
                },
                {
                    "value": 596,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 127,
            "question": "How much <b></b>boredom is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item8_Neutral.png",
                "/images/faces/Faces_Item8_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 597,
                    "label": "None"
                },
                {
                    "value": 598,
                    "label": "A little"
                },
                {
                    "value": 599,
                    "label": "Some"
                },
                {
                    "value": 600,
                    "label": "Moderate"
                },
                {
                    "value": 601,
                    "label": "A lot"
                },
                {
                    "value": 602,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 128,
            "question": "How much <b>disappointment</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item8_Neutral.png",
                "/images/faces/Faces_Item8_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 603,
                    "label": "None"
                },
                {
                    "value": 604,
                    "label": "A little"
                },
                {
                    "value": 605,
                    "label": "Some"
                },
                {
                    "value": 606,
                    "label": "Moderate"
                },
                {
                    "value": 607,
                    "label": "A lot"
                },
                {
                    "value": 608,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 129,
            "question": "How much <b>happiness</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item9_Neutral.png",
                "/images/faces/Faces_Item9_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 609,
                    "label": "None"
                },
                {
                    "value": 610,
                    "label": "A little"
                },
                {
                    "value": 611,
                    "label": "Some"
                },
                {
                    "value": 612,
                    "label": "Moderate"
                },
                {
                    "value": 613,
                    "label": "A lot"
                },
                {
                    "value": 614,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 130,
            "question": "How much <b>surprise</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item9_Neutral.png",
                "/images/faces/Faces_Item9_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 615,
                    "label": "None"
                },
                {
                    "value": 616,
                    "label": "A little"
                },
                {
                    "value": 617,
                    "label": "Some"
                },
                {
                    "value": 618,
                    "label": "Moderate"
                },
                {
                    "value": 619,
                    "label": "A lot"
                },
                {
                    "value": 620,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 131,
            "question": "How much <b>fear</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item9_Neutral.png",
                "/images/faces/Faces_Item9_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 621,
                    "label": "None"
                },
                {
                    "value": 622,
                    "label": "A little"
                },
                {
                    "value": 623,
                    "label": "Some"
                },
                {
                    "value": 624,
                    "label": "Moderate"
                },
                {
                    "value": 625,
                    "label": "A lot"
                },
                {
                    "value": 626,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 132,
            "question": "How much <b>anger</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item10_Neutral.png",
                "/images/faces/Faces_Item10_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 627,
                    "label": "None"
                },
                {
                    "value": 628,
                    "label": "A little"
                },
                {
                    "value": 629,
                    "label": "Some"
                },
                {
                    "value": 630,
                    "label": "Moderate"
                },
                {
                    "value": 631,
                    "label": "A lot"
                },
                {
                    "value": 632,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 133,
            "question": "How much <b></b>fear is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item10_Neutral.png",
                "/images/faces/Faces_Item10_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 633,
                    "label": "None"
                },
                {
                    "value": 634,
                    "label": "A little"
                },
                {
                    "value": 635,
                    "label": "Some"
                },
                {
                    "value": 636,
                    "label": "Moderate"
                },
                {
                    "value": 637,
                    "label": "A lot"
                },
                {
                    "value": 638,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 134,
            "question": "How much <b>shame</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item10_Neutral.png",
                "/images/faces/Faces_Item10_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 639,
                    "label": "None"
                },
                {
                    "value": 640,
                    "label": "A little"
                },
                {
                    "value": 641,
                    "label": "Some"
                },
                {
                    "value": 642,
                    "label": "Moderate"
                },
                {
                    "value": 643,
                    "label": "A lot"
                },
                {
                    "value": 644,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 135,
            "question": "How much <b>surprise</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item12_Neutral.png",
                "/images/faces/Faces_Item12_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 645,
                    "label": "None"
                },
                {
                    "value": 646,
                    "label": "A little"
                },
                {
                    "value": 647,
                    "label": "Some"
                },
                {
                    "value": 648,
                    "label": "Moderate"
                },
                {
                    "value": 649,
                    "label": "A lot"
                },
                {
                    "value": 650,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 136,
            "question": "How much <b>interest</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item12_Neutral.png",
                "/images/faces/Faces_Item12_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 651,
                    "label": "None"
                },
                {
                    "value": 652,
                    "label": "A little"
                },
                {
                    "value": 653,
                    "label": "Some"
                },
                {
                    "value": 654,
                    "label": "Moderate"
                },
                {
                    "value": 655,
                    "label": "A lot"
                },
                {
                    "value": 656,
                    "label": "Extreme"
                }
            ],
            "response": null
        },
        {
            "id": 137,
            "question": "How much <b>happiness</b> is expressed by the <b>Emotion Face</b>?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [
                "/images/faces/Faces_Item12_Neutral.png",
                "/images/faces/Faces_Item12_EmotionalFace.png"
            ],
            "options": [
                {
                    "value": 657,
                    "label": "None"
                },
                {
                    "value": 658,
                    "label": "A little"
                },
                {
                    "value": 659,
                    "label": "Some"
                },
                {
                    "value": 660,
                    "label": "Moderate"
                },
                {
                    "value": 661,
                    "label": "A lot"
                },
                {
                    "value": 662,
                    "label": "Extreme"
                }
            ],
            "response": null
        }
    ]
}

const emotionalSettingsTasks = {
    "id": 13,
    "name": "EmotionalSettings",
    "rank": 12,
    "practice": [
        {
            "id": 138,
            "question": "While composing music to accompany a military march, a woman feels worried when the event coordinator told her that she would need to have this musical composition completed a week earlier than planned. Now that she feels worried, what task on her list will she be able to do most effectively?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 663,
                    "label": "Compose the military march"
                },
                {
                    "value": 664,
                    "label": "Plan out the groceries needed to prepare meals for the week"
                },
                {
                    "value": 665,
                    "label": "Clean the kitchen"
                },
                {
                    "value": 666,
                    "label": "Review monthly credit card statements for accuracy"
                }
            ],
            "response": null
        }
    ],
    "attention": [
        {
            "id": 144,
            "question": "An advertising employee responsible for a new marketing campaign feels pleased when he receives an email stating that there will be free lunches at the agency today. What is the most likely job title for this employee?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 687,
                    "label": "Advertising Director"
                },
                {
                    "value": 688,
                    "label": "Engineer"
                },
                {
                    "value": 689,
                    "label": "Teacher"
                },
                {
                    "value": 690,
                    "label": "Sports Coach"
                }
            ],
            "response": null
        }
    ],
    "tasks": [
        {
            "id": 139,
            "question": "A woman is making decorations for a friend’s birthday party. She receives a call from the bank and is disappointed that her loan has been rejected. Now that she feels disappointed, which task on her list will she be able to do most effectively?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 667,
                    "label": "Create decorations for friend’s party"
                },
                {
                    "value": 668,
                    "label": "File taxes"
                },
                {
                    "value": 669,
                    "label": "Attempt to return an item that is past its refund date"
                },
                {
                    "value": 670,
                    "label": "Finish gardening and yard work"
                }
            ],
            "response": null
        },
        {
            "id": 140,
            "question": "A man is thinking about how he could improve himself over the next year. He feels accomplished after realizing that he has already made significant progress towards achieving his long-term goals. Now that he feels accomplished, which task on his list will he be able to do most effectively?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 671,
                    "label": "Reflect on which goals to tackle in the upcoming year"
                },
                {
                    "value": 672,
                    "label": "Securely package fragile items that need to be mailed"
                },
                {
                    "value": 673,
                    "label": "Call the bank to transfer savings and investments to a competitor bank"
                },
                {
                    "value": 674,
                    "label": "Create a meal using whatever ingredients are available on hand"
                }
            ],
            "response": null
        },
        {
            "id": 141,
            "question": "A facilitator is creating an evaluation plan for the wellness program. He feels disheartened after hearing that a previous participant criticized the wellness program and the facilitator. Now that he feels disheartened, which task on his list will he be able to do most effectively?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 675,
                    "label": "Develop an evaluation plan for the wellness program"
                },
                {
                    "value": 676,
                    "label": "Brainstorm new ways of promoting the wellness program"
                },
                {
                    "value": 677,
                    "label": "Call sponsors to solicit additional funding for new wellness initiatives"
                },
                {
                    "value": 678,
                    "label": "Attend a yoga session"
                }
            ],
            response: RESPONSE_DEFAULT,
        },
        {
            id: 47,
            question: 'Task 2 Question',
            options: [
                { value: 1, label: 'A' },
                { value: 2, label: 'B' },
                { value: 3, label: 'C' },
                { value: 4, label: 'D' },
            ],
            "response": null
        },
        {
            "id": 143,
            "question": "A team is working together to resolve a major client’s complaint. All team members feel frustrated after blaming each other for the client’s dissatisfaction. Now that they all feel frustrated, which task will they be able to do most effectively?",
            "description": "",
            "numberOfResponses": null,
            "played": false,
            "type": null,
            "mediaPath": [],
            "options": [
                {
                    "value": 683,
                    "label": "Collaborate as a team to address the client’s complaint"
                },
                {
                    "value": 684,
                    "label": "Brainstorm and discuss the next team building activity"
                },
                {
                    "value": 685,
                    "label": "Debate about the most pressing team challenges that must be addressed"
                },
                {
                    "value": 686,
                    "label": "Review the team’s progress in completing its annual objectives"
                }
            ],
            "response": null
        }
    ]
}

const outcome = [
    {
        id: 5001,
        question: "Question " + 5001,
        options: [
            { value: 1, label: "Label " + 1 },
            { value: 2, label: "Label " + 2 },
            { value: 3, label: "Label " + 3 },
            { value: 4, label: "Label " + 4 },
            { value: 5, label: "Label " + 5 },
        ]
    },
    {
        id: 5002,
        question: "Question " + 5002,
        options: [
            { value: 1, label: "Label " + 1 },
            { value: 2, label: "Label " + 2 },
            { value: 3, label: "Label " + 3 },
            { value: 4, label: "Label " + 4 },
            { value: 5, label: "Label " + 5 },
        ]
    },
    {
        id: 5003,
        question: "Question " + 5003,
        options: [
            { value: 1, label: "Label " + 1 },
            { value: 2, label: "Label " + 2 },
            { value: 3, label: "Label " + 3 },
            { value: 4, label: "Label " + 4 },
            { value: 5, label: "Label " + 5 },
        ]
    },
    {
        id: 5004,
        question: "Question " + 5004,
        options: [
            { value: 1, label: "Label " + 1 },
            { value: 2, label: "Label " + 2 },
            { value: 3, label: "Label " + 3 },
            { value: 4, label: "Label " + 4 },
            { value: 5, label: "Label " + 5 },
        ]
    },
    {
        id: 5005,
        question: "Question " + 5005,
        options: [
            { value: 1, label: "Label " + 1 },
            { value: 2, label: "Label " + 2 },
            { value: 3, label: "Label " + 3 },
            { value: 4, label: "Label " + 4 },
            { value: 5, label: "Label " + 5 },
        ]
    },

]

const testData = {
    facilitationTasks: facilitationTasks,
    sensationsTasks: sensationsTasks,
    moodMeterTasks: moodMeterTasks,
    textScenariosTasks: textScenariosTasks,
    contextualPicturesTasks: contextualPicturesTasks,
    changesTasks: changesTasks,
    blendsTasks: blendsTasks,
    comicStripsTasks: comicStripsTasks,
    progressionsEnergyTasks: progressionsEnergyTasks,
    progressionsPleasantTasks: progressionsPleasantTasks,
    comicStripsTasks: comicStripsTasks,
    videosTasks: videosTasks,
    textScenariosTasks: textScenariosTasks,
    facesTasks: facesTasks,
    emotionalSettingsTasks: emotionalSettingsTasks
};

export default testData;

/* LOOKUP */
export const YesOrNoOption = [
    { value: 1, text: 'No' },
    { value: 2, text: 'Yes' }
];

export const YesOrNoOrDontKnowOptions = [
    { value: 1, text: 'No' },
    { value: 2, text: 'Yes' },
    { value: 3, text: `Don't know` },
];

export const RaceOptions = [
    { value: null, text: '' },
    { value: 1, text: 'Asian; Pacific Islander', requireOther: false },
    { value: 2, text: 'Black, African American, African Canadian', requireOther: false },
    { value: 3, text: 'Native, Aboriginal', requireOther: false },
    { value: 4, text: 'White', requireOther: false },
    { value: 5, text: 'Multiracial', requireOther: false },
    { value: 6, text: 'Other', requireOther: true },
];

export const EthnicOriginsOptions = [
    { value: null, text: '' },
    { value: 1, text: 'European origins', requireOther: false },
    { value: 2, text: 'Other North American origins', requireOther: false },
    { value: 3, text: 'North American Aboriginal origins', requireOther: false },
    { value: 4, text: 'Caribbean origins', requireOther: false },
    { value: 5, text: 'Latin, Central and South American origins', requireOther: false },
    { value: 6, text: 'African origins', requireOther: false },
    { value: 7, text: 'Asian origins', requireOther: false },
    { value: 8, text: 'Oceania origins', requireOther: false },
    { value: 9, text: 'Other', requireOther: true },
];

export const GenderOptions = [
    { value: undefined, text: '', terminate: false, requireOther: false },
    { value: 1, text: 'Male', terminate: false, requireOther: false },
    { value: 2, text: 'Female', terminate: false, requireOther: false },
    { value: 3, text: 'Other', terminate: false, requireOther: true },
    { value: 4, text: 'Prefer not to answer', terminate: true, requireOther: false },
];

export const EnglishOptions = [
    { value: undefined, text: '', terminate: false },
    { value: 1, text: 'Very well', terminate: false },
    { value: 2, text: 'Well', terminate: false },
    { value: 3, text: 'Not very well', terminate: true },
    { value: 4, text: 'Not at all', terminate: true },
    { value: 5, text: `Don't know`, terminate: true },
];

export const CountryOptions = [
    { value: undefined, text: '', terminate: false, requireState: false, requireProvince: false },
    { value: 1, text: 'United States', terminate: false, requireState: true, requireProvince: false },
    { value: 2, text: 'Canada', terminate: false, requireState: false, requireProvince: true },
    { value: 3, text: 'Other', terminate: true, requireState: false, requireProvince: false },
];

export const StateOptions = [
    { value: undefined, text: '', terminate: false },
    { value: 1, text: 'Alabama', terminate: false },
    { value: 2, text: 'Alaska', terminate: false },
    { value: 3, text: 'Arizona', terminate: false },
    { value: 52, text: 'Other', terminate: true },
];

export const ProvinceOptions = [
    { value: undefined, text: '' },
    { value: 1, text: 'Alberta' },
    { value: 2, text: 'British Columbia' },
    { value: 3, text: 'Manitoba' },
];

export const EducationOptions = [
    { value: undefined, text: '' },
    { value: 1, text: `No high school diploma`},
    { value: 2, text: `Graduated from high school/GED, or alternative`},
    { value: 3, text: 'Some college or university, but did not graduate'},
    { value: 4, text: 'Trade certificate or diploma (associate degree - occupational)'},
    { value: 5, text: 'Graduated from community or technical college (associate degree - academic)'},
    { value: 6, text: `Graduated from university with bachelor's degree`},
    { value: 7, text: `Obtained a post graduate or professional degree (e.g., M.A., Ph.D., M.D., LLB, etc.)`}
]

export const StudentOptions = [
    { value: 1, text: `No`, isStudent: false },
    { value: 2, text: `Yes, full-time`, isStudent: true },
    { value: 3, text: `Yes, part-time`, isStudent: true }
]

export const DegreeOptions = [
    { value: undefined, text: '' },
    { value: 1, text: `Trade certificate or diploma`},
    { value: 2, text: `Community or technical college`},
    { value: 3, text: `Bachelor’s degree`},
    { value: 4, text: `Master’s Degree (e.g., M.A. or M.Sc.)`},
    { value: 5, text: `Master’s of Business Administration (M.B.A.)`},
    { value: 6, text: `Doctorate Degree (Ph.D.)`},
    { value: 7, text: `Professional Degree (e.g., LLB, M.D.)`},
    { value: 8, text: `Other`},
]

export const GPAOptions = [
    { value: undefined, text: '' },
    { value: 1, text: `3.5-4.0 (an “A” average)`},
    { value: 2, text: `2.5 to 3.4 (a “B” average)`},
    { value: 3, text: `1.5 to 2.4 (a “C” average)`},
    { value: 4, text: `0.5 to 1.4 (a “D” average)`},
    { value: 5, text: `0.0 to 0.4 (less than a “D” average)`},
    { value: 6, text: `Don’t Know`},
]

export const EmploymentStatusOptions = [
    { value: undefined, text: '', terminate: false, skipToUnemployment: false, requireOther: false  },
    { value: 1, text: `Employed or self-employed; full-time`, terminate: false, skipToUnemployment: false, requireOther: false },
    { value: 2, text: `Employed or self-employed; part-time`, terminate: false, skipToUnemployment: false, requireOther: false },
    { value: 3, text: `Unemployed`, terminate: false, skipToUnemployment: true, requireOther: false },
    { value: 4, text: `Retired`, terminate: false, skipToUnemployment: true, requireOther: false },
    { value: 5, text: `Other`, terminate: true, skipToUnemployment: false, requireOther: true },
]

export const OrganizationLevelOptions = [
    { value: undefined, text: '', requireOther: false, hasDirectReports: false },
    { value: 1, text: `Senior Executive (President, CEO, CFO, VP, etc.)`, requireOther: false, hasDirectReports: true },
    { value: 2, text: `Senior Manager (individuals who manage managers)`, requireOther: false, hasDirectReports: true },
    { value: 3, text: `Manager (individuals who manage others)`, requireOther: false, hasDirectReports: true },
    { value: 4, text: `Non-managerial Employee/Staff`, requireOther: false, hasDirectReports: false },
    { value: 5, text: `Other`, requireOther: true, hasDirectReports: false },
]

export const DirectReportsOptions = [
    { value: 1, text: `0`},
    { value: 2, text: `1-5`},
    { value: 3, text: `6-10`},
    { value: 4, text: `11-15`},
    { value: 5, text: `16+`},
]

export const OccupationalAreaOptions = [
    { value: undefined, text: '', requireOther: false },
    { value: 17, text: `Architecture and Engineering`, requireOther: false },
    { value: 27, text: `Arts, Design, Entertainment, Sports and Media`, requireOther: false },
    { value: 37, text: `Building, Grounds Cleaning and Maintenance`, requireOther: false },
    { value: 99, text: `Other`, requireOther: true },
]

export const OccupationOptions = [
    { value: undefined, text: '', area: 0, requireOther: false },
    {value: 1, text: `Aerospace Engineers`, area: 17, requireOther: false },
    {value: 2, text: `Agricultural Engineers`, area: 17, requireOther: false },
    {value: 3, text: `Architects, Except Naval`, area: 17, requireOther: false },
    {value: 22, text: `Other`, area: 17, requireOther: true },
    {value: 27, text: `Broadcast and Sound Engineering Technicians and Radio Operators`, area: 27, requireOther: false },
    {value: 28, text: `Dancers and Choreographers`, area: 27, requireOther: false },
    {value: 29, text: `Designers`, area: 27, requireOther: false },
    {value: 39, text: `Other`, area: 27, requireOther: true },
    {value: 40, text: `Building Cleaning Workers`, area: 37, requireOther: false },
    {value: 41, text: `First-Line Supervisors of Building and Grounds Cleaning and Maintenance Workers`, area: 37, requireOther: false },
    {value: 42, text: `Grounds Maintenance Workers`, area: 37, requireOther: false },
    {value: 43, text: `Pest Control Workers`, area: 37, requireOther: false },
    {value: 44, text: `Other`, area: 37, requireOther: true },
]

export const DiagnosedOptions = [
    { value: 1, text: 'No', terminate: false },
    { value: 2, text: 'Yes', terminate: true },
    { value: 3, text: `Don't know`, terminate: true },
];

export const getDummyLookup = (lookupName, params) => {
    switch (lookupName) {
        case LOOKUP_GENDER:
            return GenderOptions;
        case LOOKUP_RACE:
            return RaceOptions;
        case LOOKUP_ETHNIC_ORIGINS:
            return EthnicOriginsOptions;
        case LOOKUP_YESORNO:
            return YesOrNoOption;
        case LOOKUP_YESORNODONTKNOW:
            return YesOrNoOrDontKnowOptions;
        case LOOKUP_ENGLISH:
            return EnglishOptions;
        case LOOKUP_COUNTRY:
            return CountryOptions;
        case LOOKUP_STATE:
            return StateOptions;
        case LOOKUP_PROVINCE:
            return ProvinceOptions;
        case LOOKUP_EDUCATION:
            return EducationOptions;
        case LOOKUP_STUDENT:
            return StudentOptions;
        case LOOKUP_DEGREES:
            return DegreeOptions;
        case LOOKUP_GPA:
            return GPAOptions;
        case LOOKUP_EMPLOYEMENTSTATUS:
            return EmploymentStatusOptions;
        case LOOKUP_ORGANIZATIONLEVEL:
            return OrganizationLevelOptions;
        case LOOKUP_DIRECTREPORTS:
            return DirectReportsOptions;
        case LOOKUP_OCCUPATIONALAREA:
            return OccupationalAreaOptions;
        case LOOKUP_OCCUPATION:
            return OccupationOptions.filter(item => parseInt(item.area) === parseInt(params.area) || item.area === 0);
        case LOOKUP_DIAGNOSED:
            return DiagnosedOptions;
        default:
        return []
    }
}

/* TASKS */

export const tasks = [
    { id: 12},
    { id: 10},
    { id: 1},
    { id: 2},
    { id: 3},
    { id: 4},
    { id: 5},
    { id: 6},
    { id: 7},
    { id: 8},
    { id: 9},
    { id: 11},
]